export default {
    "entityPicker_error": "Se produjo un error al obtener las entidades.",
    "entityPicker_landmark": "Seleccione Landmark",
    "entityPicker_equipments": "Seleccione Equipo"
  }